import React, { useMemo, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { defaultSettings } from "css/defaultAntStyles";
import { Card, DatePicker, Space } from "antd";
import { DownloadOutlined, CommentOutlined } from "@ant-design/icons";
import { MyText } from "Components/MyText/MyText";
import { MyBtn } from "Components/MyBtn/MyBtn";
import { exportToExcel } from "../../TableWrapper/helpers/exportToExcel";
import { CommentTooltip } from "Pages/MyProjectPage/helpers/CommentTooltipForTable";
import { myTheme } from "Pages/MyProjectPage/helpers/AGTableStyles/MyTheme";
import { SearchSelectDebounce } from "Components/SearchSelectDebounce/SearchSelectDebounce";
import { getAllWorksToSelect } from "Api/WorksApi/helpers";
ModuleRegistry.registerModules([AllCommunityModule]);

// function CommentTooltip(props) {
//   if (!props.value) return null;

//   return (
//     <div
//       style={{
//         background: "#1f1f1f",
//         color: "#fff",
//         border: "1px solid #fa541c",
//         borderRadius: 8,
//         padding: 10,
//         maxWidth: 320,
//         whiteSpace: "normal",
//         wordBreak: "break-word",
//         lineHeight: 1.4,
//         boxShadow: "0 4px 12px rgba(0,0,0,0.35)",
//       }}
//     >
//       {/* <div
//         style={{
//           fontWeight: 600,
//           marginBottom: 6,
//           color: "#fa541c",
//         }}
//       >
//          Коментар
//       </div> */}

//       <div>{props.value}</div>
//     </div>
//   );
// }
export const MaterialsTable = ({
  disabled,
  projectTitle,
  projectMaterialsForTable,
  openWorkTypeSetter = false,
  changeWorkTypeTied,
}) => {
  const gridRef = useRef();
  const [checkedPeriod, setCheckedPeriod] = useState(null);
  //   const [selectedGroups, setSelectedGroups] = useState([]);
  //   const [selectedWorks, setSelectedWorks] = useState([]);

  //   const groupOptions = useMemo(() => {
  //     return [...new Set(projectWorksForTable.map((i) => i.group))].map(
  //       (group) => ({
  //         label: group,
  //         value: group,
  //       }),
  //     );
  //   }, [projectWorksForTable]);

  //   const workOptions = useMemo(() => {
  //     return [...new Set(projectWorksForTable.map((i) => i.work))].map(
  //       (work) => ({
  //         label: work,
  //         value: work,
  //       }),
  //     );
  //   }, [projectWorksForTable]);

  const filteredData = useMemo(() => {
    return projectMaterialsForTable.filter((item) => {
      //   const groupMatch =
      //     selectedGroups.length === 0 || selectedGroups.includes(item.group);

      //   const workMatch =
      //     selectedWorks.length === 0 || selectedWorks.includes(item.work);
      //   return groupMatch && workMatch;
      return item;
    });
  }, [projectMaterialsForTable]);

  const dateColumns = useMemo(() => {
    const startDate = checkedPeriod?.[0];
    const endDate = checkedPeriod?.[1];

    if (!startDate || !endDate) return [];

    const cols = [];

    let current = startDate.startOf("day");
    const last = endDate.startOf("day");

    while (current.isBefore(last) || current.isSame(last)) {
      const year = current.year();
      const month = current.month() + 1;
      const day = current.date();

      const fullDate = `${year}-${String(month).padStart(2, "0")}-${String(
        day,
      ).padStart(2, "0")}`;
      const fullDateCorrectVisualization = `${String(day).padStart(
        2,
        "0",
      )}.${String(month).padStart(2, "0")}.${year}`;

      cols.push({
        field: fullDate,
        headerName: fullDateCorrectVisualization,
        width: 105,
        editable: false,
        sortable: false,
        filter: false,
        floatingFilter: false,

        valueGetter: (params) => {
          return params.data?.[fullDate]?.value ?? null;
        },
        tooltipComponent: CommentTooltip,
        tooltipValueGetter: (params) => {
          return params.data?.[fullDate]?.comment ?? "";
        },

        cellRenderer: (params) => {
          const cell = params.data?.[fullDate];

          if (!cell) return null;

          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 4,
                width: "100%",
              }}
            >
              <span>{cell.value}</span>

              {cell.comment && (
                <CommentOutlined
                  style={{
                    color: defaultSettings.colorPrimary,
                    fontSize: 12,
                  }}
                />
              )}
            </div>
          );
        },

        cellStyle: {
          textAlign: "center",
          cursor: "pointer",
        },
      });

      current = current.add(1, "day");
    }

    return cols;
  }, [checkedPeriod]);

  const columnDefs = useMemo(() => {
    const columsData = [
      {
        field: "dateArrived",
        headerName: "Дата",
        pinned: "left",
        width: 120,
        sortable: true,
      },

      {
        field: "nomenclature",
        headerName: "Номенклатура",
        pinned: "left",
        width: 330,

        sortable: true,
      },
      {
        field: "count",
        headerName: "Кількість",
        pinned: "left",
        width: 120,

        sortable: true,

        cellStyle: {
          textAlign: "center",
        },
      },
      {
        field: "restCount",
        headerName: "Залишок",
        pinned: "left",
        width: 120,

        sortable: true,

        cellStyle: {
          textAlign: "center",
        },
      },

      {
        field: "usedCount",
        headerName: "Використано",
        pinned: "left",
        width: 120,

        sortable: true,

        cellStyle: {
          textAlign: "center",
        },
      },

      ...dateColumns,
    ];
    if (openWorkTypeSetter) {
      columsData.unshift({
        field: "workTypeTied",
        headerName: "Пов'язана робота",
        pinned: "left",
        width: 300,
        sortable: true,
        cellRenderer: (props) => {
          const workTypeTied = props.data.workTypeTied;
          const materialId = props.data.id;
          let valueToInsert = null;
          if (workTypeTied) {
            valueToInsert = {
              value: JSON.stringify(workTypeTied) + `___` + materialId,
              label:
                workTypeTied.code +
                " " +
                workTypeTied.title +
                ", " +
                workTypeTied.unit,
            };
          }

          return (
            <SearchSelectDebounce
              allowClear={true}
              disabled={disabled}
              placeholder="Пошук робіт..."
              customFetch={getAllWorksToSelect}
              onChange={(e) => {
                const worksIds = (Array.isArray(e) ? e : [])
                  .filter(Boolean)
                  .map((el) => el?.value ?? el)
                  .filter(Boolean);
                const dataValues = worksIds.map((work) => {
                  const json = work.split("___")[0];
                  const raw = JSON.parse(json);
                  return raw;
                });
                const workTypeTied = dataValues[0];
                const materialNomenclature = props.data.nomenclature;
                changeWorkTypeTied({
                  materialId,
                  workTypeTied: workTypeTied || null,
                  materialNomenclature,
                });
              }}
              value={valueToInsert}
            />
          );
        },
      });
    }
    return columsData;
  }, [dateColumns, openWorkTypeSetter, projectMaterialsForTable]);

  return (
    <div>
      <Card style={{ borderRadius: 16, marginBottom: 16 }}>
        <Space wrap style={{ display: "flex" }}>
          <Space>
            <MyText text={"Період"} />
            <DatePicker.RangePicker
              format="DD.MM.YYYY"
              onChange={setCheckedPeriod}
            />
          </Space>
          {checkedPeriod && (
            <Space>
              <MyBtn
                icon={<DownloadOutlined />}
                onClick={() => exportToExcel(gridRef, projectTitle)}
                text={"Завантажити таблицю"}
              />
            </Space>
          )}
        </Space>
      </Card>
      <div
        style={{
          width: "100%",
        }}
      >
        <AgGridReact
          ref={gridRef}
          theme={myTheme}
          rowData={filteredData}
          columnDefs={columnDefs}
          animateRows
          domLayout="autoHeight"
          rowSelection="multiple"
          suppressMovableColumns
          tooltipShowDelay={0}
          tooltipHideDelay={3000}
          getRowId={(params) => String(params.data.id)}
          defaultColDef={{
            resizable: true,
          }}
        />
      </div>
    </div>
  );
};
